<template>
  <div>
    <h3>
      Assets:
    </h3>
    <p>
      Assets include all objects that are used in campaigns. This includes assets, mostly aircraft, that can be selected
      in after action reports, both as piloted by the members as well as for claiming victories, additionally all types
      of ground targets for ground victories. They can be organized in groups and subgroups, thereby each group
      is an asset itself.
    </p>
  </div>

</template>

<script>

export default {
  name: "AssetGeneralDescriptionComp"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/AssetGeneralDescriptionComp.vue